import { UI, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Spinner } from 'native-base';
import React from 'react';

export const TicketApplicationInProgress = () => {
  return (
    <HStack
      py={Spacing['stack.giant']}
      space={Spacing['inline.xxxs']}
      alignItems="center"
      justifyContent="center">
      <Spinner size="lg" color={Color['brand.primary.principal']} accessibilityLabel="Loading..." />
      <VStack space={Spacing['stack.nano']}>
        <UI.Text variant="semibold" fontSize={Typography['fontsize.lg']}>
          Aguarde enquanto estamos processando seu envio de ordem.
        </UI.Text>
        <UI.Text>Este processo pode levar alguns segundos, não saia desta pagina.</UI.Text>
      </VStack>
    </HStack>
  );
};
